import { render, staticRenderFns } from "./RowCardConfig.vue?vue&type=template&id=3d044526&"
import script from "./RowCardConfig.vue?vue&type=script&lang=js&"
export * from "./RowCardConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports